import { getPlatform } from '@common-libs/tj-utils/platform'
import { channelTypes, getChannelInfo } from '@common-libs/tj-channel'
const {
  isTujiaAppEnv, // 途家 APP
  isCtripAppEnv, // 携程 APP
  isQunarAppEnv, // 去哪儿 APP
  isMayiAppEnv, // 蚂蚁 APP
  isElongAppEnv, // 艺龙 APP
  isTongchengAppEnv, // 同程APP
  isTEAppEnv, // 同程 艺龙APP
  isWxEnv, // 微信环境
  isWxMpEnv, // 微信小程序
  isTCQMEAppEnv, // 四方 APP
  isBrowserEnv, // 普通浏览器环境
  isMpEnv, // 微信小程序 百度小程序 支付宝小程序 头条小程序
  isWxBrowser, // 微信浏览器环境
  isTouTiaoMpEnv, // 头条小程序
  isAliMpEnv // 支付宝小程序
} = getPlatform()
const ua = window.navigator.userAgent.toLowerCase()

export const platformEnv = {
  isBrowserEnv,
  isCtripAppEnv,
  isTujiaAppEnv,
  isQunarAppEnv,
  isMayiAppEnv,
  isWxEnv,
  isWxMpEnv,
  isTEAppEnv,
  isTongchengAppEnv,
  isElongAppEnv,
  isTCQMEAppEnv,
  isMpEnv,
  isWxBrowser,
  isTouTiaoMpEnv,
  isAliMpEnv,
  isAlipayClient: ua.indexOf('alipayclient') >= 0
}

/**
 * 环境判断
 */
export default {
  0: 'NUll', // 未知
  1: 'BROWSER_ENV', // 浏览器
  2: 'TUJIA_APP_ENV', // 途家APP环境
  3: 'WX_ENV', // 微信APP环境
  4: 'WX_MP_ENV', // 微信小程序环境
  5: 'ALI_ENV', // 支付宝APP环境
  6: 'ALI_MP_ENV', // 支付宝小程序环境
  7: 'JD_APP_ENV', // 京东APP环境
  8: 'QUNAR_APP_ENV', // 去哪儿APP环境
  9: 'CTRIP_APP_ENV', // 携程APP环境
  10: 'MAYI_APP_ENV', // 蚂蚁APP环境
  11: 'QUICK_MP_ENV', // 快应用环境
  12: 'AMAP_MP_ENV', // 高德小程序环境
  13: 'BAIDU_MP_ENV', // 百度小程序环境
  14: 'TT_MP_ENV' // 头条小程序
}

